/* Click and Collect sub-status chip, Vue Component */
<template>
    <v-chip :color="ChipColor(status) + ' v-chip-light-bg'" outlined small>{{ status }}</v-chip>
</template>

<script>
// BCR-119: the Click and Collect sub-status (AB-02). Colours are mapped explicitly - like
// InvoiceStatusChip rather than OrderStatusChip - so no new theme colours are needed.
export default {
    props: {
        status: {
            type: String,
            required: false,
            default: ''
        }
    },
    methods: {
        ChipColor(status) {
            return status === 'Ready to Collect' ? 'success' : 'secondary';
        }
    }
}
</script>
